import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useConvexClient } from 'convex-vue'
import { api } from '../../convex/_generated/api'

const STORAGE_KEY = 'beitmidrash_userId'

export const useAuthStore = defineStore('auth', () => {
  const currentUser = ref(null)
  const isRehydrating = ref(false)

  const isLoggedIn = computed(() => currentUser.value !== null)
  const isAdmin = computed(() => currentUser.value?.role === 'admin')
  const userId = computed(() => currentUser.value?._id ?? null)

  function setCurrentUser(user) {
    currentUser.value = user
    if (user?._id) {
      localStorage.setItem(STORAGE_KEY, user._id)
    } else {
      localStorage.removeItem(STORAGE_KEY)
    }
  }

  function logout() {
    currentUser.value = null
    localStorage.removeItem(STORAGE_KEY)
  }

  async function rehydrate() {
    const storedId = localStorage.getItem(STORAGE_KEY)
    if (!storedId) return

    isRehydrating.value = true
    try {
      const client = useConvexClient()
      const user = await client.query(api.users.queries.get, { id: storedId })
      if (user && !user.deactivatedAt) {
        currentUser.value = user
      } else {
        localStorage.removeItem(STORAGE_KEY)
      }
    } catch {
      localStorage.removeItem(STORAGE_KEY)
    } finally {
      isRehydrating.value = false
    }
  }

  return { currentUser, isLoggedIn, isAdmin, userId, isRehydrating, setCurrentUser, logout, rehydrate }
})
